// Survey User Details - English
export default {
  header: {
    title: "Survey User",
    surveyReport: "Survey Report",
  },
  note: {
    label: "Note:",
    empty: "None",
    edit: "Edit",
  },
  buttons: {
    downloadSurveyInfo: "Download Survey Info",
  },
  walletBalance: {
    title: "Total Wallet Balance",
    tooltip:
      "The total wallet balance currently only includes balances from ETHEREUM, TRON, BSC, BTC, and Polygon addresses.\n\nBased on the currency values recorded in this system, the total balance is calculated by converting all main coins and tokens held by the address to USDT.",
    updatePrompt: "Click the button to update balance",
    update: "Update",
    partialSuccess: "(Partial address balance update successful)",
  },
  loading: {
    text: "Loading...",
  },
  statistics: {
    recharge: "Deposit (USDT)",
    withdrawal: "Withdrawal (USDT)",
    otcBuy: "OTC Buy (CNY)",
    otcSell: "OTC Sell (CNY)",
    times: "times",
  },
  tabs: {
    userBehavior: "User Behavior",
    otcTrading: "OTC Trading",
    depositWithdrawal: "Deposit/Withdrawal",
    walletBalance: "Wallet Balance",
    accountBalance: "Account Balance",
    loginDevice: "Login/Device Info",
    receiveInfo: "Receiving Info",
    paymentMethod: "Payment Method Records",
    otherInfo: "Other Info",
  },
};
